import { sendRequest } from "../../hooks/requests/useRequest";


export async function getAllCharacteristic ()
{
    const requestOptions = {
        method: 'GET'
    };

    const response = await sendRequest(requestOptions, `Characteristic/List`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function CreateCatalogs({
   characteristic
}) {
    const body = {
        characteristic
    };

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "Characteristic/Create"
    );

    if (response.code === 200)
        return {
            code: response?.code ,
          
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            response: response?.code ,

        };
}

export async function UpdateCatalogs({
    id_characteristic ,characteristic
}) {
  
    let body = {
        id_characteristic:id_characteristic,
        characteristic:characteristic,
    };
    
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, `Characteristic/Update`
    );

    if (response.code === 200)
        return {
            code: response?.code ,
          
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
           
            response: response?.code ,

        };
}



export async function DeleteCatalogs({
    id_characteristic  
}) {
  
    const requestOptions = {
        method: 'DELETE',
    };

    const response = await sendRequest(
        requestOptions, `Characteristic/${id_characteristic }`
    );

    if (response.code === 200)
        return {
            code: response?.code ,
          
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
           
            response: response?.code ,

        };
}